rhm.utils = (function (module) {

  var fadeIn = function (el) {
    el.style.opacity = 0;
    var tick = function () {
      el.style.opacity = +el.style.opacity + 0.1;
      if (+el.style.opacity < 1) {
        (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 4);
      }
    };
    tick();
  };

  function fadeInModal(el) {
    if (!el) return;
    el.style.display = 'block';
    el.style.opacity = '0';
    requestAnimationFrame(function () {
      el.style.transition = 'opacity 0.2s ease';
      el.style.opacity = '1';
    });
  }

  function fadeOutModal(el, done) {
    if (!el) {
      done && done();
      return;
    }
    el.style.transition = 'opacity 0.2s ease';
    el.style.opacity = '0';
    setTimeout(function () {
      el.style.display = 'none';
      el.style.transition = '';
      el.style.opacity = '';
      done && done();
    }, 200);
  }

  var downloadImages = function () {
    var imgDefer = document.getElementsByClassName('preload');
    for (var i = 0; i < imgDefer.length; i++) {
      var img = imgDefer[i].getAttribute('data-original');
      if (img) {
        imgDefer[i].setAttribute('src', img);
        imgDefer[i].style.display = 'block';
        fadeIn(imgDefer[i]);
      }
    }
  };

  var modalImages = function () {
    var imgDefer = document.getElementsByClassName('lazymodal');
    for (var i = 0; i < imgDefer.length; i++) {
      if (imgDefer[i].getAttribute('data-src')) {
        imgDefer[i].setAttribute('src', imgDefer[i].getAttribute('data-src'));
        fadeIn(imgDefer[i]);
      }
    }
  };

  var initListeners = function () {
    document.addEventListener('click', function (e) {
      var swell = e.target.closest && e.target.closest('.toggleSwell');
      if (swell) {
        e.preventDefault();
        try {
          swellAPI.showRewardsPopup();
        } catch (err) { console.log(err); }
        return;
      }

      var modalTrigger = e.target.closest && e.target.closest('.modalTrigger');
      if (modalTrigger) {
        e.preventDefault();
        var scroll = document.body.scrollTop || document.documentElement.scrollTop;
        document.documentElement.classList.add('noscroll');
        document.documentElement.setAttribute('data-scrolltop', String(scroll));
        var id = modalTrigger.getAttribute('data-modal');
        modalImages();
        if (id) fadeInModal(document.getElementById(id));
        return;
      }

      var expandable = e.target.closest && e.target.closest('.textbox__expandable');
      if (expandable) {
        expandable.classList.toggle('textbox__expandable--open');
        return;
      }

      var closeBtn = e.target.closest && e.target.closest('.close-dialog');
      if (closeBtn) {
        var scrollRaw = document.documentElement.getAttribute('data-scrolltop');
        var scrollPos = scrollRaw != null && scrollRaw !== '' ? Number(scrollRaw) : 0;
        document.documentElement.classList.remove('noscroll');
        var modal = closeBtn.closest('.modal');
        fadeOutModal(modal, function () {
          if (scrollPos !== 0) {
            window.scrollTo(0, scrollPos);
          }
        });
        document.documentElement.removeAttribute('data-scrolltop');
      }
    });
  };

  var cookie = {
    set: function (c_name, value, exdays) { var exdate = new Date(); exdate.setDate(exdate.getDate() + exdays); var c_value = escape(value) + ((exdays === null) ? '' : '; expires=' + exdate.toUTCString()); document.cookie = c_name + '=' + c_value; },
    delete: function (c_name) { var exdate = new Date(0); document.cookie = c_name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;'; },
    get: function (c_name) { var c_value = document.cookie; var c_start = c_value.indexOf(' ' + c_name + '='); if (c_start == -1) { c_start = c_value.indexOf(c_name + '='); } if (c_start == -1) { c_value = null; } else { c_start = c_value.indexOf('=', c_start) + 1; var c_end = c_value.indexOf(';', c_start); if (c_end == -1) { c_end = c_value.length; } c_value = unescape(c_value.substring(c_start, c_end)); } return c_value; }
  };

  module = {
    init: function () {
      initListeners();
      downloadImages();
    },
    modalImages: modalImages,
    downloadImages: downloadImages,
    fadeIn: fadeIn,
    cookie: cookie
  };

  return module;
}(window.rhm.utils));
